import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDrag } from "react-dnd";
import { ItemTypes } from "./ItemTypes";
import { BACKEND_URL } from "constants";

export const DragSource = function DragSource({ photo, requestId }) {
  const navigate = useNavigate();
  
  // 1. Add a state to track if the network request is processing
  const [isProcessing, setIsProcessing] = useState(false);
  const [mouseDown, setMouseDown] = useState(false);

  const handleAccept = () => {
    // 2. Set processing to true immediately to prevent the jump-back
    setIsProcessing(true); 
    
    const payload = {
      request_id: requestId,
    };
    
    axios
      .post(BACKEND_URL + "/request/accept", payload)
      .then((_) => {
        // refresh the page
        navigate(0);
      })
      .catch((e) => {
        console.error(e);
        // 3. Revert visibility if the API call fails
        setIsProcessing(false); 
      });
  };
  
  const [{ isDragging, difference }, drag] = useDrag(() => ({
    type: ItemTypes.DRAG_SOURCE,
    item: { photo },
    end: (item, monitor) => {
      const dropResult = monitor.getDropResult();
      if (item && dropResult) {
        handleAccept();
      }
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
      difference: monitor.getDifferenceFromInitialOffset(),
      handlerId: monitor.getHandlerId(),
    }),
  }));

  useEffect(() => {
    setMouseDown(false);
  }, [difference]);

  // 4. Check BOTH isDragging and isProcessing to determine opacity
  const opacity = isDragging || isProcessing ? 0.01 : 1; 
  const boxShadow = mouseDown ? "none" : "rgba(0, 0, 0, 0.24) 0px 3px 8px";

  return (
    <div
      ref={drag}
      style={{ opacity, boxShadow }}
      onMouseDown={() => setMouseDown(true)}
      onTouchStart={() => setMouseDown(true)}
      className={"drag-source shadow-hover"}
      data-testid={`drag-source`}
    >
      {photo}
    </div>
  );
};